import { gsap } from "gsap";

export function initAccordion(): void {
  const accordions = document.querySelectorAll("[data-accordion]");

  accordions?.forEach((accordion) => {
    const headingElement = accordion.querySelector("[data-accordion-heading]");
    const arrow = headingElement?.querySelector("svg");
    const panel = accordion?.querySelector("[data-accordion-panel]");

    const tl = gsap.timeline();

    const toggleDirection = () => {
      tl.reversed() ? tl.play() : tl.reverse();
    };

    if (panel && arrow) {
      tl.to(arrow, { rotate: 180, duration: 0.2 });
      tl.to(
        panel,
        {
          height: "auto",
          autoAlpha: 1,
          duration: 0.2,
        },
        "<",
      );

      // set the reversed property to true
      tl.reversed(true);
    }

    headingElement?.addEventListener("click", toggleDirection);
  });
}
